export enum RedoMarketplaceProductFieldType {
  Title = "title",
  Description = "description",
  Vendor = "vendor",
  Price = "price",
}
